import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ICPLAuthTestClient, NotificationStyles, NotificationTypes } from "./api/cplauthapi/CPLAuthAPI";

export interface IAuthTestService {
  testSignalRNotification(
    userID: string,
    notificationType: NotificationTypes,
    notificationStyle: NotificationStyles
  ): Promise<void>;
}

@injectable()
export class AuthTestService implements IAuthTestService {
  @inject(SERVICE_TYPES.CPLAuthTestClient) cplAuthTestClient!: ICPLAuthTestClient;

  testSignalRNotification(
    userID: string,
    notificationType: NotificationTypes,
    notificationStyle: NotificationStyles
  ): Promise<void> {
    return this.cplAuthTestClient.testSignalRNotification(userID, notificationType, notificationStyle);
  }
}
